import {
 GET_ORIGIN_DATA
} from "../actions/types";

const initialState = {};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ORIGIN_DATA:
            return {
                ...state,
                data: action.payload,
            };
        default :
            return state;
    }
}
